import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksBudgetingSection', {
    sectionTitle: 'Budget',
    description: 'The following budgets would be affected by the approval of this request:',
    budgetName: 'Budget name',
    budgetPeriod: 'Budget period',
    class: 'Class',
    location: 'Location',
    customer: 'Customer',
    category: 'Category',
    remainingBudget: 'Remaining budget ({currency})',
    amount: 'Amount ({currency})',
    status: 'Status',
});
